import { Slide } from '@/components/core/Slide';
import audioFile from './18-eva-hackathon.mp3';

const autoNextDuration = 22000;
const transcript = `
  Ja, laten we verder gaan met de sessie. Ik zet deze video wel even uit, want het leidt af...  

  Wij zijn gevraagd om jullie te inspireren over het gebruik van AI tijdens deze hackathon. En dat doen wij graag... 
  AI is geen tovermiddel, maar een krachtig hulpmiddel dat – mits goed ingezet – creatieve en impactvolle 
  oplossingen kan bieden.
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      autoNext={autoNextDuration}
      audio={audioFile}
      visualizer="full"
      networkBackground="full"
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
